var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useCallback, useState } from 'react';
import { useGoogleAnalytics } from '@happynumbers/front-utils';
import { ShadowBox } from '@hn-ui/boxes';
import { styled } from 'styled-components';
import { useToggle } from '@hn-front/utils';
import { LinkButton } from '@hn-ui/buttons';
import { Tag as IconTag, Warning, Team, Locked } from '@hn-ui/icons';
import PrintModal from './PrintModal';
import PackCarousel from './PackCarousel';
import { gaTrackerIds } from '../../../pages/utils';
import { RestrictAccessPremium } from './RestrictAccessPremium';
import { RestrictAccessInvite } from './RestrictAccessInvite';
import { RateSection } from './RateSection';
import { RateModal } from './RateModal';
import { usePostEvent } from '../Common/hooks/usePostEvent';
var Label = styled.div.withConfig({ displayName: "Label", componentId: "sc-1p8dscz" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 16px;\n  overflow-wrap: break-word;\n"], ["\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  margin-bottom: 16px;\n  overflow-wrap: break-word;\n"])));
var ScShadowBox = styled(ShadowBox).withConfig({ displayName: "ScShadowBox", componentId: "sc-e0htb2" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 320px;\n  div[data-id='content-box'] {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n  }\n  &:not(:nth-child(3n)) {\n    margin-right: 16px;\n  }\n\n  padding-bottom: 32px;\n"], ["\n  width: 320px;\n  div[data-id='content-box'] {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n  }\n  &:not(:nth-child(3n)) {\n    margin-right: 16px;\n  }\n\n  padding-bottom: 32px;\n"])));
var Content = styled.div.withConfig({ displayName: "Content", componentId: "sc-c2p3vr" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding: 16px 16px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding: 16px 16px;\n"])));
var Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-2iaip8" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  &:nth-child(n + 2) {\n    margin-top: 16px;\n  }\n"], ["\n  display: flex;\n  &:nth-child(n + 2) {\n    margin-top: 16px;\n  }\n"])));
var TagWrapper = styled.div.withConfig({ displayName: "TagWrapper", componentId: "sc-mtqrkc" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  &:not(:last-child) {\n    margin-bottom: 8px;\n  }\n"], ["\n  display: flex;\n  &:not(:last-child) {\n    margin-bottom: 8px;\n  }\n"])));
var TagBlock = styled.div.withConfig({ displayName: "TagBlock", componentId: "sc-1pv3pqp" })(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""])));
var Tag = styled(LinkButton).withConfig({ displayName: "Tag", componentId: "sc-7d537p" })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: auto;\n  margin-right: 8px;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  white-space: break-spaces;\n  text-align: left;\n"], ["\n  width: auto;\n  margin-right: 8px;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  white-space: break-spaces;\n  text-align: left;\n"])));
var TagIcon = styled(IconTag).withConfig({ displayName: "TagIcon", componentId: "sc-o7m1sf" })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  vertical-align: middle;\n  margin-right: 10px;\n"], ["\n  vertical-align: middle;\n  margin-right: 10px;\n"])));
var PrepTime = styled.div.withConfig({ displayName: "PrepTime", componentId: "sc-t3gk14" })(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  color: ", ";\n  &:not(:last-child) {\n    margin-bottom: 8px;\n  }\n"], ["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  color: ", ";\n  &:not(:last-child) {\n    margin-bottom: 8px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black50;
});
var Cooperative = styled.div.withConfig({ displayName: "Cooperative", componentId: "sc-155ypjq" })(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  color: ", ";\n"], ["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black50;
});
var WarningIcon = styled(Warning).withConfig({ displayName: "WarningIcon", componentId: "sc-5r5e8h" })(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  vertical-align: middle;\n  margin-right: 10px;\n  margin-top: -3px;\n"], ["\n  vertical-align: middle;\n  margin-right: 10px;\n  margin-top: -3px;\n"])));
var CooperativeIcon = styled(Team).withConfig({ displayName: "CooperativeIcon", componentId: "sc-15goxso" })(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  vertical-align: middle;\n  margin-right: 10px;\n  margin-top: -3px;\n"], ["\n  vertical-align: middle;\n  margin-right: 10px;\n  margin-top: -3px;\n"])));
var ScLocked = styled(Locked).withConfig({ displayName: "ScLocked", componentId: "sc-cejsix" })(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  margin-right: 8px;\n"], ["\n  margin-right: 8px;\n"])));
var setMaxHeightForComponentsInRow = function (elementRef) {
    var elementHeights = elementRef.current.map(function (_a) {
        var offsetHeight = _a.offsetHeight;
        return offsetHeight;
    });
    var titleMaxHeight = Math.max.apply(Math, elementHeights);
    elementRef.current.forEach(function (_a) {
        var style = _a.style;
        style.height = titleMaxHeight + "px";
    });
};
var InnerContent = styled.div.withConfig({ displayName: "InnerContent", componentId: "sc-1ukdmb8" })(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  @media (hover: hover) and (pointer: fine) {\n    cursor: pointer;\n    &:hover ", " {\n      color: ", ";\n    }\n  }\n"], ["\n  @media (hover: hover) and (pointer: fine) {\n    cursor: pointer;\n    &:hover ", " {\n      color: ", ";\n    }\n  }\n"])), Label, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue50;
});
var ScRateSection = styled(RateSection).withConfig({ displayName: "ScRateSection", componentId: "sc-6dzl7k" })(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  margin: 0 16px;\n"], ["\n  margin: 0 16px;\n"])));
var ratePrintable = function (_a) {
    var printableId = _a.printableId, ratePosition = _a.ratePosition, text = _a.text, answers = _a.answers;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _b, _c, _d, _e;
        return __generator(this, function (_f) {
            data = {
                rating: ratePosition,
                notes: text,
                instructable: (_b = answers === null || answers === void 0 ? void 0 : answers.find(function (_a) {
                    var text = _a.text;
                    return text === 'It supported my instruction well';
                })) === null || _b === void 0 ? void 0 : _b.result,
                clear_for_students: (_c = answers === null || answers === void 0 ? void 0 : answers.find(function (_a) {
                    var text = _a.text;
                    return text === 'Instructions were clear for students';
                })) === null || _c === void 0 ? void 0 : _c.result,
                levels_difference: (_d = answers === null || answers === void 0 ? void 0 : answers.find(function (_a) {
                    var text = _a.text;
                    return text === 'Levels were differentiated effectively';
                })) === null || _d === void 0 ? void 0 : _d.result,
                skills_tagging: (_e = answers === null || answers === void 0 ? void 0 : answers.find(function (_a) {
                    var text = _a.text;
                    return text === 'Skills were tagged correctly';
                })) === null || _e === void 0 ? void 0 : _e.result,
            };
            return [2 /*return*/, fetch("/api/teachers/printables/packs/" + printableId + "/review", {
                    method: 'put',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })];
        });
    });
};
export var Pack = function (_a) {
    var printableId = _a.id, title = _a.name, preparationTime = _a.preparationTime, cooperative = _a.cooperative, skills = _a.skills, standards = _a.standards, contents = _a.contents, grade = _a.grade, locked = _a.locked, lockReason = _a.lockReason, availableToReview = _a.availableToReview, handleOnPackTagClick = _a.onPackTagClick, titleRef = _a.titleRef, tagRef = _a.tagRef, prepTimeRef = _a.prepTimeRef, cooperativeRef = _a.cooperativeRef, rest = __rest(_a, ["id", "name", "preparationTime", "cooperative", "skills", "standards", "contents", "grade", "locked", "lockReason", "availableToReview", "onPackTagClick", "titleRef", "tagRef", "prepTimeRef", "cooperativeRef"]);
    var _b = useToggle(), isRestrictAccessPremium = _b.isToggled, toggleRestrictAccessPremium = _b.toggle;
    var _c = useToggle(), isRateModal = _c.isToggled, toggleRateModal = _c.toggle;
    var _d = useToggle(), isRestrictAccessInvite = _d.isToggled, toggleRestrictAccessInvite = _d.toggle;
    var _e = useToggle(), isToggled = _e.isToggled, toggle = _e.toggle;
    var isNeedPrepTime = Boolean(preparationTime);
    var ga4 = useGoogleAnalytics(gaTrackerIds);
    var handleOnLabelClick = useCallback(function () {
        ga4 === null || ga4 === void 0 ? void 0 : ga4.sendEventAsTeacher('click_pack_name', {
            category: 'Printables',
        });
    }, [ga4]);
    var handleOnPackClick = useCallback(function () {
        if (!locked) {
            toggle();
            return;
        }
        if (lockReason === 'premium')
            toggleRestrictAccessPremium();
        else if (lockReason === 'invite_colleagues')
            toggleRestrictAccessInvite();
    }, [
        toggle,
        toggleRestrictAccessPremium,
        toggleRestrictAccessInvite,
        lockReason,
        locked,
    ]);
    var handleOnPremium = useCallback(function () {
        document.location.href = '/pricing';
    }, []);
    var postEvent = usePostEvent()[0];
    var handleOnInvite = useCallback(function () {
        postEvent('invite_colleagues_no_addons', { type: 'printables' }).then(function () {
            document.location.href = '/teachers/boarding';
        });
    }, []);
    var _f = useState(availableToReview), showStars = _f[0], setShowStars = _f[1];
    var _g = useState(), currentRate = _g[0], setCurrentRate = _g[1];
    var handleOnRatePrintable = useCallback(function (value) {
        ratePrintable({ printableId: printableId, ratePosition: value })
            .then(function (res) { return res.json(); })
            .then(function () {
            toggleRateModal();
            setCurrentRate(value);
            setShowStars(false);
        });
    }, [toggleRateModal]);
    var handleOnSubmitRatePrintable = useCallback(function (text, answers) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ratePrintable({ printableId: printableId, text: text, answers: answers })];
                case 1:
                    _a.sent();
                    setShowStars(false);
                    toggleRateModal();
                    return [2 /*return*/];
            }
        });
    }); }, [toggleRateModal]);
    var handleOnCloseRateModal = useCallback(function () {
        setShowStars(false);
        toggleRateModal();
        setCurrentRate(undefined);
    }, [toggleRateModal]);
    var handleOnDownloaded = useCallback(function () {
        setShowStars(true);
        setCurrentRate(undefined);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs(ScShadowBox, __assign({}, rest, { children: [_jsxs(InnerContent, __assign({ "data-testid": 'pack', onClick: handleOnPackClick }, { children: [_jsx(PackCarousel, { data: contents }, void 0), _jsxs(Content, { children: [_jsxs(Label, __assign({ ref: titleRef, onClick: handleOnLabelClick }, { children: [locked && _jsx(ScLocked, { color: 'black10' }, void 0), " ", title] }), void 0), _jsxs(TagWrapper, __assign({ ref: tagRef, "data-testid": 'tags' }, { children: [_jsx(TagIcon, { size: 16 }, void 0), _jsxs(TagBlock, { children: [skills.map(function (_a) {
                                                        var id = _a.id, text = _a.text;
                                                        return (_jsx(Tag, __assign({ size: 'xSmall', onClick: function (event) {
                                                                event.stopPropagation();
                                                                handleOnPackTagClick({
                                                                    skillId: id,
                                                                    type: "skill" /* skill */,
                                                                });
                                                            } }, { children: text }), id));
                                                    }), standards.map(function (_a) {
                                                        var id = _a.id, text = _a.text;
                                                        return (_jsx(Tag, __assign({ size: 'xSmall', onClick: function (event) {
                                                                event.stopPropagation();
                                                                handleOnPackTagClick({
                                                                    standardId: id,
                                                                    type: "standard" /* standard */,
                                                                });
                                                            } }, { children: text }), id));
                                                    })] }, void 0)] }), void 0), isNeedPrepTime && (_jsxs(PrepTime, __assign({ ref: prepTimeRef }, { children: [_jsx(WarningIcon, { size: 16, color: 'yellow80' }, void 0), "Prep Time: ", preparationTime, " min"] }), void 0)), cooperative && (_jsxs(Cooperative, __assign({ ref: cooperativeRef }, { children: [_jsx(CooperativeIcon, { size: 16, color: 'yellow80' }, void 0), "Cooperative"] }), void 0))] }, void 0)] }), void 0), showStars && (_jsx(ScRateSection, { onRate: handleOnRatePrintable, selectedPosition: currentRate, readonly: Boolean(currentRate) }, void 0))] }), void 0), _jsx(PrintModal, { open: isToggled, onClose: handleOnPackClick, title: title, contents: contents, printableId: printableId, grade: grade, onDownloaded: handleOnDownloaded }, void 0), isRestrictAccessPremium && locked && (_jsx(RestrictAccessPremium, { onClose: toggleRestrictAccessPremium, onPremiumClick: handleOnPremium }, void 0)), isRestrictAccessInvite && locked && (_jsx(RestrictAccessInvite, { onClose: toggleRestrictAccessInvite, onPremiumClick: handleOnPremium, onInviteClick: handleOnInvite }, void 0)), isRateModal && currentRate && (_jsx(RateModal, { onClose: handleOnCloseRateModal, packName: title, position: currentRate, onSubmit: handleOnSubmitRatePrintable }, void 0))] }, void 0));
};
var PackRow = function (_a) {
    var data = _a.data, handleOnPackTagClick = _a.onPackTagClick, lockReason = _a.lockReason, rest = __rest(_a, ["data", "onPackTagClick", "lockReason"]);
    var titleRef = useRef([]);
    var tagRef = useRef([]);
    var prepTimeRef = useRef([]);
    var cooperativeRef = useRef([]);
    titleRef.current = titleRef.current.slice(0, data.length);
    tagRef.current = tagRef.current.slice(0, data.length);
    prepTimeRef.current = prepTimeRef.current.slice(0, data.length);
    cooperativeRef.current = cooperativeRef.current.slice(0, data.length);
    useEffect(function () {
        setMaxHeightForComponentsInRow(titleRef);
        setMaxHeightForComponentsInRow(tagRef);
        setMaxHeightForComponentsInRow(prepTimeRef);
        setMaxHeightForComponentsInRow(cooperativeRef);
    }, []);
    return (_jsx(Wrapper, __assign({ "data-testid": 'pack-row' }, rest, { children: data.map(function (props, i) {
            var currentTitle = function (el) {
                titleRef.current[i] = el;
            };
            var currentTag = function (el) {
                tagRef.current[i] = el;
            };
            var currentPrepTime = function (el) {
                prepTimeRef.current[i] = el;
            };
            var currentCooperative = function (el) {
                cooperativeRef.current[i] = el;
            };
            return (_createElement(Pack, __assign({}, props, { titleRef: currentTitle, tagRef: currentTag, prepTimeRef: currentPrepTime, cooperativeRef: currentCooperative, onPackTagClick: handleOnPackTagClick, key: props.id, lockReason: lockReason })));
        }) }), void 0));
};
export default PackRow;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;
